<template>
    <v-content style="background-color: #DADADA">
        <Header></Header>

        <!-- Banner dialog -->
        <v-dialog
                persistent
                v-model="bannerDialog"
                :width="$vuetify.breakpoint.smAndUp ? '900':'300'"
        >
            <v-card style="position: relative">
                <v-btn small color="red"
                       @click="bannerDialog = !bannerDialog"
                       style="position: absolute; z-index: 99; right: 5px; top: 5px">
                    <v-icon color="white">close</v-icon>
                </v-btn>

                <div style="background-color: #FFF">
                    <img style="width: 100%" class="hidden-xs-only my-n2" :src="require('../assets/banner/banner.png')">
                    <img style="width: 100%" class="hidden-sm-and-up my-n2"
                         :src="require('../assets/banner/banner-mobile.png')">
                </div>
                <v-layout justify-center pa-5 style="background-color: #DADADA">
                    <v-flex shrink>
                        <v-btn @click="bannerDialogClickHandler" color="#E99B07">
                            {{ $t('page.home.dialog.button') }}
                            <v-icon class="ml-1">chevron_right</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
        <!-- End banner dialog -->

        <img class="hidden-xs-only" style="width: 100%; margin-bottom: -7px" :src="require('../assets/bg/cover.png')">
        <img class="hidden-sm-and-up" style="width: 100%;" :src="require('../assets/bg/bg-mobile.png')">


    <video :src="require('../assets/video/centro-hd.mp4')" controls autoplay muted loop width="100%"></video>

        <v-layout justify-center pa-8 style="background-color: #FFF">
            <v-flex md8>

                <v-layout justify-center mb-10 mt-5>
                    <v-flex shrink class="txt-head">
                        THE CENTRO CONDO
                    </v-flex>
                </v-layout>

                <div class="mb-10">
                    <span>{{ $t('page.home.introduction') }}</span>
                </div>

                <v-layout justify-center>
                    <v-flex>
                        <img style="width: 100%;" class="plan-img" :src="require('../assets/plan/flr-1.jpg')">
                    </v-flex>
                </v-layout>

            </v-flex>
        </v-layout>

        <v-layout justify-center
                  :style="{ 'background': `url(${require('../assets/bg/bookingbg.png')})`, 'background-size': 'cover' }">
            <v-flex shrink pa-4 text-center>
                <div class="mb-3 txt-semi-head">Booking online</div>
                <div>{{ $t('page.home.bookingIntro') }}</div>
            </v-flex>
        </v-layout>

        <v-layout justify-space-around pa-5 ref="timer" id="timer">
            <v-flex shrink>
                <div class="px-2 py-1 boxTimer" style="width: 136px">
                    {{ timeBox | moment("DD/MM/YYYY")}}
                </div>
            </v-flex>
            <v-flex shrink>
                <v-icon>schedule</v-icon>
                <div class="ml-3 px-2 py-1 boxTimer" style="width: 117px">
                    {{ timeBox | moment("HH:mm:ss")}}
                </div>
            </v-flex>
        </v-layout>
        <v-layout justify-space-around pa-5 id="stickytimer" v-show="showStickyTimer">
            <v-flex shrink>
                <div class="px-2 py-1 boxTimer" style="width: 136px">
                    {{ timeBox | moment("DD/MM/YYYY")}}
                </div>
            </v-flex>
            <v-flex shrink>
                <v-icon>schedule</v-icon>
                <div class="ml-3 px-2 py-1 boxTimer" style="width: 117px">
                    {{ timeBox | moment("HH:mm:ss")}}
                </div>
            </v-flex>
        </v-layout>

        <template v-for="(roomType, index) in roomTypes">
            <!-- Type 1 -->
            <RoomOffer
                :key="index"
                :type="roomType"
                :rooms-remaining="roomType.availableCount"
                :img="require('../assets/type/type1.png')"
                :price="roomType.minimum"
            ></RoomOffer>
        </template>

        <Footer></Footer>
    </v-content>
</template>

<script>
    import Footer from '../components/Footer'
    import Header from "../components/Header"
    import Service from '../services'
    import RoomOffer from "../components/RoomOffer";
    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'home',
        components: {
            Footer,
            Header,
            RoomOffer
        },
        data: () => ({
            bannerDialog: true,
            timeBox: new Date().toISOString(),
            showStickyTimer: false
        }),
        computed: {
            ...mapState({
                roomTypes: state => state.roomType.roomTypes,
            }),
        },
        created() {
            this.recordedSender()
            setInterval(() => {
                this.timeBox = new Date().toISOString()
            }, 1000)
            this.onGetAllRoomTypes()
        },
        mounted () {
            window.addEventListener("scroll", this.onScroll)
        },
        destroyed () {
            console.info('destroyed on scroll')
            window.removeEventListener("scroll", this.onScroll, true)
        },
        methods: {
            ...mapActions('roomType', ['onGetAllRoomTypes']),
            ...mapActions('roomSelected', ['onClearBooking']),
            recordedSender() {
                let data = {
                    user_activity_type_id: 1,
                    uuid: Math.random().toString(36).substring(5, 10) + '-' + Math.random().toString(36).substring(5, 10) + '-' + Math.random().toString(36).substring(5, 10),
                    value: this.$route.path
                };
                // console.log(data)
                Service.record.sendActivityData(data)
            },
            onScroll () {
                const timerOffsetTop = this.$refs.timer.offsetTop
                const pageYOffset = window.pageYOffset

                this.showStickyTimer = pageYOffset >= timerOffsetTop
            },
            async bannerDialogClickHandler () {
                await this.onClearBooking()
                this.$router.push('/room-select');
                this.bannerDialog = !this.bannerDialog
            }
        }
    }
</script>

<style scoped>
    .boxTimer {
        border: solid 1px #979797;
        background: #EEEEEE;
        border-radius: 4px;
        font-size: 17px;
        display: inline-block;
        text-align: center;
    }
    #stickytimer {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: rgb(218, 218, 218);
        z-index: 99;
    }

    .v-btn:not(.v-btn--round).v-size--small {
        min-width: unset;
        width: 30px;
    }
</style>
